import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FirebaseAuthComponent } from 'src/app/shared/firebase-auth/firebase-auth.component';
import { MessagesService } from 'src/app/shared/services/messages/message.service';
import { AutorizacionImagenes } from '../tiposFormulario/documents/autorizacion-imagenes';
import { RecogidaMenores } from '../tiposFormulario/documents/recogida-menores';
import { Student } from '../tiposFormulario/student';



@Component({
  selector: 'app-evaluations',
  templateUrl: './evaluations.component.html',
  styleUrls: ['./evaluations.component.scss']
})
export class EvaluationComponent extends BaseComponent  implements OnInit {

  @Input()
  public user;
  public userAuth;

  public tempIndex = 0;
  public student = new Student();
  public currentDate = new Date();
  public months = {
    0: 'Enero', 1: 'Febrero', 2: 'Marzo', 3: 'Abril', 4: 'Mayo', 5: 'Junio', 6: 'Julio', 7: 'Agosto',
    8: 'Septiembre', 9: 'Octubre', 10: 'Noviembre', 11: 'Diciembre'
  };
  public monthsToShow = [];
  public arrEvaluationRange = { ene: 0, feb: 1, mar: 2, abr: 3, may: 4, jun: 5, jul: 6, ago: 7, sep: 8, oct: 9, nov: 10, dic: 11 };
  public projectWinner = {};
  public evaluationsToShow = {};

  public readonly chevronLeft = faChevronLeft;
  public readonly chevronRight = faChevronRight;

  @Input()
  public projects: any[];

  @Output()
  public propagar = new EventEmitter<any>();

  @Output()
  public verPdf = new EventEmitter<any>();

  public recogidaMenores = new RecogidaMenores();
  public authImagenes = new AutorizacionImagenes();

  constructor(public firebaseAuth: FirebaseAuthComponent,
              private firestore: AngularFirestore) {

      super();
  }

  ngOnInit(): void {
    this.courseCurrent = this.students[this.studentCurrent].courseInfoArr[0];
    console.log('el user en documentos es ', this.user);
  }

  consultarEvaluations(idStudent: any, dateRange: string): Promise<any> {
    const arrRange = dateRange.split('-');
    const firstMonth = this.arrEvaluationRange[arrRange[0]];
    const endMonth = this.arrEvaluationRange[arrRange[1]];
    const currentDate = new Date();
    let year = currentDate.getFullYear();
    if (firstMonth === 8) {
      if (currentDate.getMonth() < 8) {
        year -= 1;
      }
    }
    if (firstMonth === 0 || firstMonth === 3) {
      if (currentDate.getMonth() >= 8) {
        year += 1;
      }
    }
    const startDate = new Date(year, firstMonth, 1);
    const endDate = new Date(year, endMonth + 1, 0);
    const courseRef = this.firestore.collection('courses').doc(this.courseCurrent.id).ref;
    return this.firestore.collection('evaluations').ref
    .orderBy('startDate', 'asc').startAt(startDate).endAt(endDate)
      // where('startDate', '>=', startDate)
      .get().then(evalu => {
        if (!evalu.empty) {
          const objPromedio = {
            concentracion: 0, convivencia: 0, docente: 0, ejecucion: 0, iniciativa: 0,
            concentracionTotal: 0, convivenciaTotal: 0, docenteTotal: 0, ejecucionTotal: 0, iniciativaTotal: 0
          };
          let contCon = 0;
          let contConvi = 0;
          let contDoc = 0;
          let contEje = 0;
          let contIni = 0;
          let flagStudentWithEvaluations = false;
          evalu.forEach(evaluation => {
            const evalData: any = evaluation.data();
            const studentEval = evalData.studentEvaluation.filter(x => x.student.id === idStudent);
            if (studentEval.length > 0) {
              flagStudentWithEvaluations = true;
              studentEval.forEach(value => {
                Object.entries(value).forEach(entry => {
                  const entrada: any = entry[1];
                  if (entrada && entrada.concentracion && entrada.project) {
                    // console.log(entry);
                    if (entrada.concentracion !== 'Ausente') {
                      objPromedio.concentracion = (entrada.concentracion.includes('.5')) ?
                        parseFloat(entrada.concentracion) : parseInt(entrada.concentracion, 10);
                      objPromedio.concentracionTotal += objPromedio.concentracion;
                      contCon++;
                    }
                    if (entrada.convivencia !== 'Ausente') {
                      objPromedio.convivencia = (entrada.convivencia.includes('.5')) ?
                        parseFloat(entrada.convivencia) : parseInt(entrada.convivencia, 10);
                      objPromedio.convivenciaTotal += objPromedio.convivencia;
                      contConvi++;
                    }
                    if (entrada.docente !== 'Ausente') {
                      objPromedio.docente = (entrada.docente.includes('.5')) ?
                        parseFloat(entrada.docente) : parseInt(entrada.docente, 10);
                      objPromedio.docenteTotal += objPromedio.docente;
                      contDoc++;
                    }
                    if (entrada.ejecucion !== 'Ausente') {
                      objPromedio.ejecucion = (entrada.ejecucion.includes('.5')) ?
                        parseFloat(entrada.ejecucion) : parseInt(entrada.ejecucion, 10);
                      objPromedio.ejecucionTotal += objPromedio.ejecucion;
                      contEje++;
                    }
                    if (entrada.iniciativa !== 'Ausente') {
                      objPromedio.iniciativa = (entrada.iniciativa.includes('.5')) ?
                        parseFloat(entrada.iniciativa) : parseInt(entrada.iniciativa, 10);
                      objPromedio.iniciativaTotal += objPromedio.iniciativa;
                      contIni++;
                    }
                    const totalProject = objPromedio.iniciativa + objPromedio.concentracion + objPromedio.convivencia +
                      objPromedio.docente + objPromedio.ejecucion;
                    if (this.projectWinner[dateRange] &&
                      this.projectWinner[dateRange].filter(data => data.projectSaved.id === entrada.project.id).length > 0) {
                      this.projectWinner[dateRange] = this.projectWinner[dateRange].map(x => {
                        if (x.projectSaved.id === entrada.project.id) {
                          x.totalProjectSaved += totalProject;
                        }
                      });
                    } else {
                      const objectProject = { totalProjectSaved: totalProject, projectSaved: entrada.project };
                      if (this.projectWinner[dateRange]) {
                        this.projectWinner[dateRange].push(objectProject);
                      } else {
                        this.projectWinner[dateRange] = [objectProject];
                      }
                    }
                  }
                });
              });
            }
          });

          if (this.projectWinner && this.projectWinner[dateRange]) {
            this.projectWinner[dateRange].sort((a, b) => {
              if (a.totalProjectSaved < b.totalProjectSaved) {
                return 1;
              }
              if (a.totalProjectSaved > b.totalProjectSaved) {
                return -1;
              }
              return 0;
            });
          }

          console.log('el project winner es ', this.projectWinner);

          contCon = (contCon === 0) ? 1 : contCon;
          contConvi = (contConvi === 0) ? 1 : contConvi;
          contDoc = (contDoc === 0) ? 1 : contDoc;
          contEje = (contEje === 0) ? 1 : contEje;
          contIni = (contIni === 0) ? 1 : contIni;
          // console.log('el contador es ', cont);
          const concentracionTotal = (objPromedio.concentracionTotal / contCon).toFixed(1);
          const convivenciaTotal = (objPromedio.convivenciaTotal / contConvi).toFixed(1);
          const docenteTotal = (objPromedio.docenteTotal / contDoc).toFixed(1);
          const ejecucionTotal = (objPromedio.ejecucionTotal / contEje).toFixed(1);
          const iniciativaTotal = (objPromedio.iniciativaTotal / contIni).toFixed(1);
          const rangeObject = {
            concentracion: (concentracionTotal.includes('.5')) ? parseFloat(concentracionTotal) :
              Math.round(parseInt(concentracionTotal, 10)),
            convivencia: (convivenciaTotal.includes('.5')) ? parseFloat(convivenciaTotal) :
              Math.round(parseInt(convivenciaTotal, 10)),
            docente: (docenteTotal.includes('.5')) ? parseFloat(docenteTotal) :
              Math.round(parseInt(docenteTotal, 10)),
            ejecucion: (ejecucionTotal.includes('.5')) ? parseFloat(ejecucionTotal) :
              Math.round(parseInt(ejecucionTotal, 10)),
            iniciativa: (iniciativaTotal.includes('.5')) ? parseFloat(iniciativaTotal) :
              Math.round(parseInt(iniciativaTotal, 10))
          };

          let studentEvaluation = this.evaluationsToShow;
          if (!studentEvaluation['course_' + this.courseCurrent.id]) {
            const courseEval = studentEvaluation;
            courseEval['course_' + this.courseCurrent.id] = [];
            studentEvaluation = courseEval;
          }

          if (studentEvaluation['course_' + this.courseCurrent.id].filter(x => x[dateRange]).length > 0) {
            studentEvaluation = studentEvaluation['course_' + this.courseCurrent.id].map(evalua => {
              if (evalua[dateRange]) {
                evalua[dateRange] = rangeObject;
              }

              return evalua;
            });
          }

          if (flagStudentWithEvaluations) {
            studentEvaluation['course_' + this.courseCurrent.id].push({ [dateRange]: rangeObject });
            this.evaluationsToShow = studentEvaluation;
          } else {
            this.addEvaluationManual(dateRange);
          }
      } else {
        this.addEvaluationManual(dateRange);
        }
        return true;
      }).catch(x => {
        throw x;
      });
    // }
  }

  addEvaluationManual(dateRange: string): void {
    let rangeObject = { concentracion: -1, convivencia: -1, docente: -1, ejecucion: -1, iniciativa: -1 };
    if (this.students[this.studentCurrent].studentEvaluation
     && this.students[this.studentCurrent].studentEvaluation['course_' + this.courseCurrent.id]) {
      rangeObject = this.students[this.studentCurrent].studentEvaluation['course_' + this.courseCurrent.id]
      .filter(eva => eva[dateRange]);
    }
    const  studentEvaluation = { ['course_' + this.courseCurrent.id]:  rangeObject };
    this.evaluationsToShow = studentEvaluation;
  }

  async generarEvaluation(idStudentSend: string, dateRangeSend: string): Promise<any> {
    console.log(idStudentSend, ' ', dateRangeSend);
    if (this.projectWinner[dateRangeSend]) {
      const objectToSend = {
        projectWinner: this.projectWinner, dateRange: dateRangeSend,
        evaluationsToShow: this.evaluationsToShow, studentCurrent: this.studentCurrent,
        courseCurrent: this.courseCurrent
      };
      this.propagar.emit(objectToSend);
    } else {
      this.consultarEvaluations(idStudentSend, dateRangeSend)
        .then(value => {
          const objectToSend = {
            projectWinner: this.projectWinner, dateRange: dateRangeSend,
            evaluationsToShow: this.evaluationsToShow, studentCurrent: this.studentCurrent,
            courseCurrent: this.courseCurrent
          };
          this.propagar.emit(objectToSend);
        });
    }
  }

  imprimirPdf(item: any): void {
    // console.log('el item elegido es ', item);
    this.verPdf.emit(item.value);
  }
}
